<div id="fachgebiete" class="page-wrapper">

	<app-menu [activeMenuIndex]="6">
	</app-menu>

	<!--<div class="subheader-bar-wrapper">
		<div class="subheader-content">
			<a href="https://www.lsd-diagnostik-partner.de/" target="_blank">
				<div class="subheader-content-text">
					Ihr kostenfreies Testset!
				</div>
			</a>
		</div>
	</div>-->

	<div class="title-wrapper">
    <div class="m-t-30 img-header">
      <img src="/assets/img/template/03-nephrologie/nephro-header.png" />
    </div>
		<h1>
			Nephrologie
		</h1>
    <h2>
      Wann sollte in der
      Nephrologie an das
      Vorliegen eines Morbus
      Fabry gedacht werden?
    </h2>
    <p>Bei nicht anderweitig erklärten Befunden; dazu gehören:</p>
		<div class="title-description">
      <ul class="bullet-nephrologie">
        <li>Albuminurie, Proteinurie</li>
        <li>Progrediente Einschränkung der Nierenfunktion</li>
        <li>Verminderte Kreatinin-Clearance</li>
        <li>Polyurie, Polydipsie</li>
        <li>Glomerulosklerose</li>
        <li>Häufige Nierenzysten</li>
        <li>Terminale Niereninsuffizienz, Nierenersatztherapie</li>
      </ul>
		</div>
	</div>

	<div class="info-section fullwidth info-ribbon color-white bgcolor-nephrologie">
    <p class="info-section-subtitle2 text-center">
      <strong>20–30 % aller nephrologischen
      Patienten haben eine nicht<br>
      zufriedenstellende Diagnose!<sup class="info-section-text-ref">1</sup></strong>
		</p>
    <div class="ribbon-center"><img src="/assets/img/template/03-nephrologie/dreieck-2.png"></div>
	</div>

  <div class="m-t-50 m-b-50"></div>

  <div class="info-section fullwidth info-ribbon with-video-float color-nephrologie bgcolor-nephrologie-inverted">
    <div class="ribbon-left"><img src="/assets/img/template/03-nephrologie/dreieck-1.png"></div>
    <div class="info-section-title">
			Wann sollte in der Nephrologie an Morbus Fabry gedacht werden?
		</div>
    <p class="text-center">
      Dies erläutert Dr. Fabian Braun, Hamburg, im Nephrologie-Expertenvideo.
		</p>
    <div class="video-float">
      <iframe src="https://www.youtube.com/embed/qwX_U0wNsAU" class="nephrologie" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
	</div>

  <!--  <app-login zone="education">-->
    <app-login zone="2000000017232"> <!-- Development -->
  <!--  <app-login zone="2000000017235"> <!-- Takeda Server -->
  <!--    <app-login zone="2000000017235"> <!-- Production -->
  </app-login>

<app-footer>
</app-footer>
</div>
